import PDFPageViewer from './PDFPageViewer';
import SupportEmail from "../components/SupportEmail";

const IntellectualProperty = () => {
  const pdfUrl = "https://omegavoid.com/documents/Omega_Void_Provisional_Patent.pdf";

  return (
    <>
      <div className="ip-container">
        <h1>Intellectual Property & Cyber Crime Protection</h1>

        <div className="legal-disclaimer">
          <div className="disclaimer-header">
            <div className="disclaimer-icon"></div>
            <h2>Legal Notice</h2>
          </div>
          <p>
            This system is patent-pending under U.S. intellectual property law. Unauthorized use, duplication, or imitation of
            this platform will be prosecuted.
          </p>
        </div>

        <div className="ip-introduction">
          <p>
            Omega Ops Cybernetics Defence Corp. has developed several cutting-edge systems that are protected
            under intellectual property law. Our innovations represent significant advancements in decentralized
            cyber-defence and secure communications technology.
          </p>
        </div>

        <div className="patent-section">
          <h2>Provisionally Patented System</h2>

          <div className="patent-item">
            <div className="patent-header">
              <h3>Omega Void™</h3>
              <span className="patent-status">Patent Pending</span>
            </div>

            <div className="patent-content">
              <PDFPageViewer pdfUrl={pdfUrl} loadingText="Loading patent document..." />

              <div className="patent-description">
                <p>
                  Our flagship decentralized visual cyber-defence messaging platform.
                  The Omega Void™ system provides unprecedented security through distributed
                  authentication protocols and zero-knowledge architecture.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SupportEmail />
    </>
  );
};

export default IntellectualProperty;
